<div class="table-responsive" *ngIf="dataSource.data.length > 0">
    <mat-table [dataSource]="dataSource" *ngIf="!editing">
        <ng-container [matColumnDef]="col.key" *ngFor="let col of columnsSchema">
            <mat-header-cell *matHeaderCellDef>
                <h4>{{ col.label }}</h4>
            </mat-header-cell>

            <mat-cell *matCellDef="let element">
                <div [ngSwitch]="col.key">
                    <div *ngSwitchCase="'createdEdited'">
                        <div>{{getElementValue(element,0)}} {{getElementValue(element,1)}} (
                            {{getElementValue(element,2)}})</div>
                        <div>Created : {{getElementValue(element,5)}}</div>
                        <div *ngIf="getElementValue(element,6)">Editied : {{getElementValue(element,6)}}</div>
                    </div>
                    <div *ngSwitchCase="'comments'">
                        {{getElementValue(element,4)}}
                    </div>
                </div>
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>

    <mat-table [dataSource]="dataSource" *ngIf="editing">
        <ng-container [matColumnDef]="col.key" *ngFor="let col of columnsSchemaEdit">
            <mat-header-cell *matHeaderCellDef>                
                <h4>{{(action==3 && col.key=='isEdit') ? '' : col.label }}</h4>
                
            </mat-header-cell>

            <mat-cell *matCellDef="let element">
                <div *ngIf="element.isEdit == false" [ngSwitch]="col.key">
                    <div *ngSwitchCase="'createdEdited'">
                        <div *ngIf="element.question.lstQuestionValueDataView[0].Value.split('|').length > 1">
                            <div>{{getElementValue(element,0)}} {{getElementValue(element,1)}} (
                                {{getElementValue(element,2)}} )</div>
                            <div>Created : {{getElementValue(element,5)}}</div>
                            <div *ngIf="getElementValue(element,6)">Editied : {{getElementValue(element,6)}}</div>
                        </div>
                    </div>
                    <div *ngSwitchCase="'comments'">
                        {{getElementCommentValue(element,4)}}
                    </div>

                    <div *ngSwitchCase="'isEdit'">
                        <div *ngIf="editing && action!=3 && getElementValue(element,2)==this.loginTokenService.getUser().USER_ID">
                            <button mat-icon-button color="primary" (click)="editRow(element)" [matTooltip]="'Edit'">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <confirm-popover [buttonType]="'mini-icon'" [icon]="'delete'" [color]="'warn'"
                                [popoverMsg]="'Delete Confirmation'" [popoverConfirmText]="'Delete'"
                                [popoverConfirmColor]="'warn'" [tooltip]="'Delete'" (onConfirm)="removeRow(element)"
                                >
                            </confirm-popover>
                        </div>
                    </div>
                </div>

                <div *ngIf="element.isEdit == true && editing" [ngSwitch]="col.key">
                    <div *ngSwitchCase="'createdEdited'">
                        <div *ngIf="element.question.lstQuestionValueDataView[0].Value.split('|').length >1">
                            <div>{{getElementValue(element,0)}} {{getElementValue(element,1)}} (
                                {{getElementValue(element,2)}})</div>
                            <div>Created : {{getElementValue(element,5)}}</div>
                            <div *ngIf="getElementValue(element,6)">Editied : {{getElementValue(element,6)}}</div>
                        </div>
                    </div>

                    <div *ngSwitchCase="'comments'">
                        <mat-form-field style="width:500%">
                            <textarea matInput [(ngModel)]="this.comment"></textarea>
                        </mat-form-field>
                    </div>

                    <div *ngSwitchCase="'isEdit'">
                        <mat-icon *ngIf="isSaving">
                            <mat-spinner *ngIf="isSaving" diameter="20"></mat-spinner>
                        </mat-icon>
                        <div *ngIf="element.isDelete == false && isSaving == false">
                            <button mat-icon-button color="primary" (click)="updateRow(element)"
                                [disabled]="disableSubmit(element)">
                                <mat-icon>done</mat-icon>
                            </button>
                            <button mat-icon-button (click)="cancelRow(element)">
                                <mat-icon class="icon-display">cancel</mat-icon>
                            </button>
                        </div>

                    </div>
                </div>
            </mat-cell>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumnsEdit"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumnsEdit"></mat-row>
    </mat-table>

    <mat-paginator [length]="dataSource.data.length" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons
        aria-label="Select page of periodic elements"></mat-paginator>
</div>